<!-- <ng-template #dpaBlockUi>
    <p-button
        [pTooltip]="
            !checkIfCanSave()
                ? ('data-protection.save-data-protection-first' | translate)
                : ('data-protection.missing-data-for-save' | translate)
        "
        class="flex"
        styleClass="flex items-center"
        [loading]="isSaving"
        icon="fa fa-save"
        [label]="'data-protection.save-data-protection-first' | translate"
        [disabled]="checkIfCanSave()"
        (onClick)="saveToUnlockEditMode()"
    ></p-button>
</ng-template>

<blockable-div #dpaBlock [blocked]="!model.id" [blockUi]="dpaBlockUi"> -->
<!-- make sure addressId is in there first render -->
@if (model.id) {
    <!-- Todo controlls and managment -->
    <div style="text-align: center; margin: 1em">
        @if (isComponentRendered()) {
            <app-asset-file-input
                (selectFiles)="createAssets($event)"
                [noUploadButton]="true"
                [dropZoneTargetModelSig]="assetListRef().table()?.el"
            />
        }
    </div>
    <app-widget-asset-list
        [dataTestId]="'formly-data-protection-assets'"
        #assetList
        [showUploadButton]="true"
        (isComponentRendered)="isComponentRendered.set(true)"
        (selectFiles)="createAssets($event)"
        [modelIdSig]="model.id"
        [modelTypeSig]="'DataProtectionAsset'"
    />
}
<!-- </blockable-div> -->
